import {useState, useEffect, ChangeEventHandler} from 'react';

interface Props {
  value: boolean;
  name?: string | undefined;
  text?: string | undefined;
  error?: string | undefined;
  onInput?: (_: any) => void;
}

const CCheckbox = ({ value, name, text, error, onInput }: Props) => {
  const [inputValue, setInputValue] = useState(false);
  const [hideError, setHideError] = useState(true);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  useEffect(() => {
    if (error) setHideError(false);
  }, [error]);

  const handleInput: ChangeEventHandler<HTMLInputElement> = e => {
    e.persist();
    const { checked } = e.target;
    setInputValue(checked);
    onInput?.(checked);
    setHideError(true);
  };

  return (
    <label>
      <div className="c-input__box">
        <input
          type="checkbox"
          className="c-checkbox"
          name={name}
          onChange={handleInput}
          checked={inputValue}
        />
        <span
          className="c-checkbox__label"
          dangerouslySetInnerHTML={{
            __html: text as string
          }}
        />
      </div>
      {!hideError && <p className="c-form__error">{error}</p>}
    </label>
  );
};

export default CCheckbox;
